<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="(size*13)/17"
    :height="size"
    viewBox="0 0 13 17"
  ><g><g><path
    :fill="color"
    d="M11.294 15.038H1.936V3.808h1.872v.467c0 .259.21.468.467.468h4.68c.258 0 .468-.21.468-.468v-.467h1.871zM4.744 2.872h.935c.259 0 .468-.21.468-.468a.468.468 0 0 1 .936 0c0 .258.21.468.468.468h.936v.936H4.743zm6.55 0H9.423v-.468a.468.468 0 0 0-.468-.468H7.939A1.408 1.408 0 0 0 6.615 1c-.61 0-1.13.391-1.324.936H4.275a.468.468 0 0 0-.467.468v.468H1.936A.937.937 0 0 0 1 3.808v11.23c0 .515.42.936.936.936h9.358c.516 0 .936-.42.936-.936V3.808a.937.937 0 0 0-.936-.936z"
  /><path
    fill="none"
    :stroke="color"
    stroke-miterlimit="50"
    stroke-width=".3"
    d="M11.294 15.038H1.936V3.808h1.872v.467c0 .259.21.468.467.468h4.68c.258 0 .468-.21.468-.468v-.467h1.871zM4.744 2.872h.935c.259 0 .468-.21.468-.468a.468.468 0 0 1 .936 0c0 .258.21.468.468.468h.936v.936H4.743zm6.55 0H9.423v-.468a.468.468 0 0 0-.468-.468H7.939A1.408 1.408 0 0 0 6.615 1c-.61 0-1.13.391-1.324.936H4.275a.468.468 0 0 0-.467.468v.468H1.936A.937.937 0 0 0 1 3.808v11.23c0 .515.42.936.936.936h9.358c.516 0 .936-.42.936-.936V3.808a.937.937 0 0 0-.936-.936z"
  /></g></g></svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#3B334A',
    },
    size: {
      type: Number,
      default: 12,
    },
  },
};
</script>
